import * as types from "../actions/actionTypes";

const initialState = {
  blogs: [],
  blog: null,
  activeBlogs: [],
  inActiveBlogs: [],
  blogCategories: [],
};

const blogs = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_BLOGS_RESPONSE:
      return { ...state, blogs: action.payload };
    case types.GET_BLOGS_RESPONSE:
      return { ...state, blog: action.payload };

    case types.CREATE_BLOGS:
      return { ...state, blog: null };
    case types.UPDATE_BLOGS:
      return { ...state, blog: null };
    case types.DELETE_BLOGS:
      return { ...state, blog: null };
    case types.GET_ACTIVE_BLOG_RESPONSE:
      return { ...state, activeBlogs: action.payload };
    case types.GET_INACTIVE_BLOG_RESPONSE:
      return { ...state, inActiveBlogs: action.payload };
    case types.GET_ALL_BLOG_CATEGORY_RESPONSE:
      return { ...state, blogCategories: action.payload };

    default:
      return state;
  }
};

export default blogs;
